import React, { useState, useEffect, version } from 'react';
import { connect } from '../../redux/store';
import { compose, withProps } from 'recompose';
import { I18n, Moment, fetchTaskRuns } from '@kineticdata/react';
import semver from 'semver';
import {
  ActivityFeed,
  Card,
  CardCol,
  CardRow,
  InfoMessage,
} from '@kineticdata/bundle-common';
import classNames from 'classnames';

const mapStateToProps = state => ({
  coreVersion: state.app.coreVersion,
});

const RunsListComponent = props =>
  props.spaceAdmin ? (
    <ul className="activity activity--comments" role="tabpanel">
      <ActivityFeed
        feedKey={props.feedKey}
        pageSize={25}
        joinByDirection="DESC"
        joinBy="createdAt"
        dataSources={props.dataSources}
        showCount={true}
        contentProps={{ hidePaging: true, emptyMessage: 'No runs to display' }}
      />
    </ul>
  ) : (
    <InfoMessage title="You do not have access to view the runs" />
  );

const RunCard = ({ run, version }) => {
  const v61 = semver.satisfies(semver.coerce(version), '>=6.1.0');
  //Check for 6.0 or 6.1 link
  const link = v61
    ? '/app/console/#/space/workflow/trees/builder/tree'
    : '/app/console/#/workflow/runs/builder/tree';
  return (
    <li className={classNames('activity__row')}>
      <Card>
        <CardCol>
          <CardRow type="subtitle" className="align-items-baseline">
            <a
              href={`${link}/${run.tree.title}/runs/${run.id}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <I18n>Run</I18n> {run.id}
            </a>
            <span className="mx-2">{'\u00b7'}</span>
            <small>
              <Moment
                timestamp={run.createdAt}
                format={Moment.formats.dateTime}
              />
            </small>
          </CardRow>
          <CardRow type="meta" className="text-muted">
            {run.tree.sourceGroup}
          </CardRow>
        </CardCol>
      </Card>
    </li>
  );
};

export const RunsList = compose(
  connect(mapStateToProps),
  withProps(props => {
    return {
      dataSources: {
        runs: {
          fn: fetchTaskRuns,
          params: (prevParams, prevResult) =>
            prevParams && prevResult
              ? prevResult.more
                ? {
                    ...prevParams,
                    offset: prevParams.offset + prevParams.limit,
                  }
                : null
              : {
                  sourceId: props.id,
                  treeType: 'Tree',
                  limit: 50,
                  offset: 0,
                  count: false,
                  include: 'details',
                },
          transform: result => ({ data: result.runs }),
          component: run => (
            <RunCard run={run} key={run.id} version={props.coreVersion} />
          ),
        },
      },
    };
  }),
)(RunsListComponent);
